import React, {useEffect, useMemo, useState} from "react";
import "./AdminDashboard.css"
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container'
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  TextField
} from '@mui/material';
import dayjs from 'dayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import uploadFileToBlob from '../../components/admin/upload/AzureBlobStorage'
import {format} from 'date-fns'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import {useDispatch} from 'react-redux'
import {unwrapResult} from '@reduxjs/toolkit'
import {updateConcept} from '../../store/conceptsSlice'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import Stack from '@mui/material/Stack';
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import HealthChoices from "../../components/admin/culinary-concepts/HealthOptionsModal";
import Fuse from "fuse.js";
import { useConfigs } from "../../configuration/useConfigs";
import RegionCountriesSelector from "../../components/RegionCountriesSelector";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InfoModal from "../../components/admin/culinary-concepts/InfoModal";

export default function EditProductLaunch() {
  const {conceptId} = useParams()
  const [concept, setConcept] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [brandEndList, setBrandEndList] = useState([]);
  const { config } = useConfigs();

  const containerName = config.AZURE_STORAGE_CONTAINER;
  const storageAccountName = config.AZURE_STORAGE_ACCOUNT_NAME;
    
  const fallbackSrc = "/images/default-ppt.png";
  const [image, setImage] = useState({preview: fallbackSrc, raw: ""});
  const [originalImageName, setOriginalImageName] = useState(null);

  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      const elementId = location.hash.replace('#', ''); // Remove the '#' symbol
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    }
  }, [location]);

  const fetchBrandsBySegmentId = async (segmentId, setList) => {
    try {
      let response = await fetch(`api/brands/segment/${segmentId}`);
      if (response.status === 200) {
        let data = await response.json();
        setList(data);
      } else {
        throw `Error fetching brand list for segment id ${segmentId}`;
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetch('api/conceptitems/GetConceptItem/' + conceptId)
      .then((data) => data.json())
      .then((data) => {
        //  console.log("DATA:: " + JSON.stringify(data))
        if (data.blobImageName) {
          setOriginalImageName(data.blobImageName);
          let imagePath = `https://${storageAccountName}.blob.core.windows.net/${containerName}/images/concepts/`
            + format(new Date(data.creationDate), 'yyyy') + '/'
            + format(new Date(data.creationDate), 'MMM').toLowerCase() + '/' + data.blobImageName;
          data.blobImageName = imagePath;
        } else {
          data.blobImageName = fallbackSrc;
        }
        setConcept(data)
        if (data.segment) {
          fetchBrandsBySegmentId(data.segment, setBrandList)
          fetchBrandsBySegmentId(data.segmentEnd, setBrandEndList)
        }
      })
  }, [])

  return (
    <>
      <Stack spacing={2} direction="row" sx={{margin: "20px auto 0", maxWidth: 1250}}>

        <Button
          variant="contained"
          color="secondary"
          size="large"

          href="/admin/"
        >
          ADMIN DASHBOARD
        </Button>

      </Stack>
      <ConceptsFormik
        fetchBrandsBySegmentId={fetchBrandsBySegmentId}
        brandList={brandList}
        brandEndList={brandEndList}
        setBrandList={setBrandList}
        setBrandEndList={setBrandEndList}
        concept={{
          id: concept.id,
          conceptName: concept.conceptName,
          pricePoint: concept.pricePoint ?? '',
          websiteUrl: concept.websiteUrl ?? '',
          description: concept.description,
          creationDate: concept.creationDate,
          chef: concept.chef,
          regionCountries: concept.regionCountries,
         // regionalInsight: concept.regionalInsight,
          brand: concept.brand ? concept.brand : 999,
          brandOtherText: concept.brandOtherText,
          segment: concept.segment,
          brandEnd: concept.brandEnd ? concept.brandEnd : 999,
          segmentEnd: concept.segmentEnd, 
          brandEndOtherText: concept.brandEndOtherText,
          healthOptions: concept.healthOptions,
          productCat1: concept.productCat1,
          productCat1Description: concept.productCat1Description,
          // productCat1Innovation: concept.productCat1Innovation,
          productCat1Code: concept.productCat1Code,
          productCat2: concept.productCat2,
          productCat2Description: concept.productCat2Description,
          // productCat2Innovation: concept.productCat2Innovation,
          productCat2Code: concept.productCat2Code,
          productCat3: concept.productCat3,
          productCat3Description: concept.productCat3Description,
          // productCat3Innovation: concept.productCat3Innovation,
          productCat3Code: concept.productCat3Code,
          productCat4: concept.productCat4,
          productCat4Description: concept.productCat4Description,
          // productCat4Innovation: concept.productCat4Innovation,
          productCat4Code: concept.productCat4Code,
          photoURL: concept.blobImageName,
          originalImageName: originalImageName,
          publishedDate: concept.publishedDate,
        }}/>
    </>
  )
}

const ConceptsFormik = (props) => {
  const {fetchBrandsBySegmentId, brandList, brandEndList, setBrandList, setBrandEndList} = props;
  const fallbackSrc = "/images/default-ppt.png";
  const [chefList, setChefList] = useState([]);
  //const [mealpartList, setMealPartList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [healthOptList, setHealthOptList] = useState([]);
  // const [productInnoList, setProductInnoList] = useState([]);
  const [productCatList, setProductCatList] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const FILE_SIZE_MAX = 500000
  const [image, setImage] = useState({preview: fallbackSrc, raw: ""});
  const [savingConcept, setSavingConcept] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);
  const [shipToSearchTerm, setShipToSearchTerm] = useState(undefined);
  const [endCustomerSearchTerm, setEndCustomerSearchTerm] = useState(undefined);
  const [filteredBrands, setFilteredBrands] = useState(brandList);
  const [filteredBrandsEnd, setFilteredBrandsEnd] = useState(brandList); 

  const OTHER_BRAND_OPTION = {id: '999', brandName: 'Other Brand'};
  const brandListWithOther = useMemo(() => {
    // Sort brandList alphabetically and place OTHER_BRAND_OPTION at the top
    const sortedBrands = [...brandList].sort((a, b) => a.brandName.localeCompare(b.brandName));
    return [OTHER_BRAND_OPTION, ...sortedBrands];
  }, [brandList]);

  const fuse = useMemo(() => {
    return new Fuse(brandListWithOther, {
      keys: ['brandName'],
      includeScore: true,
      shouldSort: true,
      threshold: 0.3,
      distance: 300,
    });
  }, [brandListWithOther]);

  useEffect(() => {
    setFilteredBrands(brandListWithOther);
  }, [brandListWithOther]);

  const brandEndListWithOther = useMemo(() => {
    // Sort brandList alphabetically and place OTHER_BRAND_OPTION at the top
    const sortedBrands = [...brandEndList].sort((a, b) => a.brandName.localeCompare(b.brandName));
    return [OTHER_BRAND_OPTION, ...sortedBrands];
  }, [brandEndList]);

  const fuseBrandsEnd = useMemo(() => {
    return new Fuse(brandListWithOther, {
      keys: ['brandName'],
      includeScore: true,
      shouldSort: true,
      threshold: 0.3,
      distance: 300,
    });
  }, [brandEndListWithOther]);

  useEffect(() => {
    setFilteredBrandsEnd(brandEndListWithOther);
  }, [brandEndListWithOther]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const PRODUCT_DESCRIPTION_MAX_LENGTH = 80;
  const PRODUCT_CODE_MAX_LENGTH = 50;

  useEffect(() => {
    // fetch('api/mealparts')
    //   .then((data) => data.json())
    //   .then((data) => setMealPartList(data))

    fetch('api/chefs')
      .then((data) => data.json())
      .then((data) => setChefList(data), [])

    fetch('api/countries')
      .then((data) => data.json())
      .then((data) => setRegionList(data.sort((a, b) => a.countryLongName.localeCompare(b.countryLongName))))

    fetch('api/healthoptions')
      .then((data) => data.json())
      .then((data) => setHealthOptList(data))

    // fetch('api/ProductInnovations')
    //   .then((data) => data.json())
    //   .then((data) => setProductInnoList(data))

    fetch('api/productcategories')
      .then((data) => data.json())
      .then((data) => setProductCatList(data))

    fetch('api/segments')
      .then((data) => data.json())
      .then((data) => setSegmentList(data))
  }, [])

  const initialBrand = props.concept.brandOtherText && (!props.concept.brand || String(props.concept.brand) !== '999')
    ? '999'
    : String(props.concept.brand);
  
  const initialBrandEnd = props.concept.brandEndOtherText && (!props.concept.brandEnd || String(props.concept.brandEnd) !== '999')
    ? '999'
    : String(props.concept.brandEnd);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: props.concept.id,
      conceptName: props.concept.conceptName,
      pricePoint: props.concept.pricePoint ?? '',
      websiteUrl: props.concept.websiteUrl ?? '',
      description: props.concept.description,
      creationDate: props.concept.creationDate,
      chef: props.concept.chef,
      regionCountries: props.concept.regionCountries,
      brand: initialBrand,
      brandOtherText: props.concept.brandOtherText ?? '',
      segment: props.concept.segment,
      brandEnd: initialBrandEnd,
      brandEndOtherText: props.concept.brandEndOtherText ?? '',
      segmentEnd: props.concept.segmentEnd,
      healthOptions: props.concept.healthOptions?.map(option => option.id) ?? [],
      productCat1: props.concept.productCat1,
      productCat1Description: props.concept.productCat1Description,
      // productCat1Innovation: props.concept.productCat1Innovation,
      productCat1Code: props.concept.productCat1Code,
      productCat2: props.concept.productCat2,
      productCat2Description: props.concept.productCat2Description,
      // productCat2Innovation: props.concept.productCat2Innovation,
      productCat2Code: props.concept.productCat2Code,
      productCat3: props.concept.productCat3,
      productCat3Description: props.concept.productCat3Description,
      // productCat3Innovation: props.concept.productCat3Innovation,
      productCat3Code: props.concept.productCat3Code,
      productCat4: props.concept.productCat4,
      productCat4Description: props.concept.productCat4Description,
      // productCat4Innovation: props.concept.productCat4Innovation,
      productCat4Code: props.concept.productCat4Code,
      photoURL: props.concept.photoURL,
      photo: null,
      publishedDate: props.concept.publishedDate,
    },
    validationSchema: Yup.object({
      conceptName: Yup.string()
        .required('Product launch name is required'),
     // mealPart: Yup.string()
      //  .required('Meal part is required'),
      description: Yup.string()
        .required('Description is required'),
      chef: Yup.string()
        .required('Chef is required'),
      regionCountries: Yup.array()
        .of(Yup.string().required('Country or region must be a string'))
        .min(1, 'At least one country or region required'),
      segment: Yup.string()
        .required('Ship To Segment is required'),
      brand: Yup.string()
        .required('Ship To Brand is required'),
      brandOtherText: Yup.string().ensure().when('brand', {
        is: OTHER_BRAND_OPTION.id,
        then: Yup.string().required('Brand is required'),
      segmentEnd: Yup.string()
        .required('End Customer Segment is required'),
      brandEnd: Yup.string()
        .required('End Customer Brand is required'),
      }),      
      brandEndOtherText: Yup.string().ensure().when('brandEnd', {
        is: OTHER_BRAND_OPTION.id,
        then: Yup.string().required('Brand is required')
      }),
      productCat1: Yup.number()
        .required('At least one product category is required'),
      productCat1Description: Yup.string().when('productCat1', {
        is: (productCat1) => productCat1,
        then: Yup.string().required('Enter a description for this product'),
        otherwise: Yup.string(),
      }),
      productCat2Description: Yup.string().when('productCat2', {
        is: (productCat2) => productCat2,
        then: Yup.string().required('Enter a description for this product'),
        otherwise: Yup.string(),
      }),
      productCat3Description: Yup.string().when('productCat3', {
        is: (productCat3) => productCat3,
        then: Yup.string().required('Enter a description for this product'),
        otherwise: Yup.string(),
      }),
      productCat4Description: Yup.string().when('productCat4', {
        is: (productCat4) => productCat4,
        then: Yup.string().required('Enter a description for this product'),
        otherwise: Yup.string().nullable(true),
      }),
      // photo: Yup.mixed()
      //    .nullable(true)
      //    .notRequired()
      //    .test("FILE_SIZE_MAX", "Uploaded file is too big. Maximum 5 MB.",
      //      value => value && (value.size <= FILE_SIZE_MAX)),
    }),
    onSubmit: values => {
      //if not default image push image to azure
      if (values.photo) {
        onImageUpload(image.raw)
      }
      saveConcept(values)
    },
  });


  function transFormToNumber(value) {
    return value === 0 ? null : Number(value);
  }

  function saveConcept(formData) {
    if (savingConcept)
      return

    var fileName = null
    if (image.raw) {
      fileName = image.raw.name

    } else if (props.concept.originalImageName) {
      fileName = props.concept.originalImageName
    }

    const healthOptions = healthOptList.filter(opt => formData.healthOptions.some(s => s === opt.id));

    var data = {
      id: formData.id,
      ConceptName: formData.conceptName,
      WebsiteUrl: formData.websiteUrl,
      PricePoint: formData.pricePoint,
      Brand: formData.brand,
      BrandOtherText: formData.brandOtherText,
      Segment: transFormToNumber(formData.segment),
      BrandEnd: transFormToNumber(formData.brandEnd),
      SegmentEnd: transFormToNumber(formData.segmentEnd),
      BrandEndOtherText: formData.brandEndOtherText,
      Chef: formData.chef,
      Description: formData.description,
      CreationDate: new Date(formData.creationDate).toISOString(),
      RegionCountries: formData.regionCountries,
     // RegionalInsight: formData.regionalInsight,
      BlobImageName: fileName,
      healthOptions: healthOptions,
      ProductCat1: transFormToNumber(formData.productCat1),
      ProductCat1Description: formData.productCat1Description,
      // ProductCat1Innovation: formData.productCat1Innovation,
      ProductCat1Code: formData.productCat1Code,
      ProductCat2: transFormToNumber(formData.productCat2),
      ProductCat2Description: formData.productCat2Description,
      // ProductCat2Innovation: formData.productCat2Innovation,
      ProductCat2Code: formData.productCat2Code,
      ProductCat3: transFormToNumber(formData.productCat3),
      ProductCat3Description: formData.productCat3Description,
      // ProductCat3Innovation: formData.productCat3Innovation,
      ProductCat3Code: formData.productCat3Code,
      ProductCat4: transFormToNumber(formData.productCat4),
      ProductCat4Description: formData.productCat4Description,
      // ProductCat4Innovation: formData.productCat4Innovation,
      ProductCat4Code: formData.productCat4Code,
      PublishedDate: props.concept.publishedDate
    };

    console.log("save data:::" + JSON.stringify(data))
    setSavingConcept(true);

    dispatch(updateConcept(data))
      .then(unwrapResult).then(originalPromiseResult => {
      setSavingConcept(false);
      setSnackbar({children: 'Product launch saved successfully', severity: 'success'});

    }).then(() => {
      if (props.concept.publishedDate) {
        navigate('/product-launches')
      } else {
        navigate('/admin')
      }
    })

      .catch(rejectedValueOrSerializedError => {
        console.log(rejectedValueOrSerializedError);
        setSavingConcept(false);
        setSnackbar({children: 'Failed to save product launch', severity: 'error'});
      });
  }

  const { config } = useConfigs();
  const AZURE_STORAGE_ACCOUNT_NAME = config.AZURE_STORAGE_ACCOUNT_NAME;
  const AZURE_STORAGE_SAS_TOKEN = config.AZURE_STORAGE_SAS_TOKEN;
  const AZURE_STORAGE_CONTAINER = config.AZURE_STORAGE_CONTAINER;

  const [sameAsShipTo, setSameAsShipTo] = useState(false);

  const onImageUpload = async (file) => {
    // *** UPLOAD TO AZURE STORAGE ***  

    let imagePath = 'images/concepts/'
      + format(new Date(formik.values.creationDate), 'yyyy') + '/'
      + format(new Date(formik.values.creationDate), 'MMM').toLowerCase() + '/';
    await uploadFileToBlob(imagePath, file, AZURE_STORAGE_ACCOUNT_NAME, AZURE_STORAGE_SAS_TOKEN, AZURE_STORAGE_CONTAINER);
  }

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const calculateInitialVisibleProducts = () => {
    const productCatValues = [
      formik.values.productCat1,
      formik.values.productCat2,
      formik.values.productCat3,
      formik.values.productCat4
    ];

    return productCatValues.filter((cat) => cat !== undefined && cat !== null && cat !== '').length || 1;
  };

  const [visibleProducts, setVisibleProducts] = useState(1);

  useEffect(() => {
    const initialVisibleProducts = calculateInitialVisibleProducts();
    setVisibleProducts(initialVisibleProducts);
  }, [formik.values]);

  useEffect(() => {
    if (sameAsShipTo) {
      formik.setFieldValue('segmentEnd', formik.values.segment);
      fetchBrandsBySegmentId(formik.values.segment, setBrandEndList).then(() => {
        formik.setFieldValue('brandEnd', formik.values.brand);
      });
      formik.setFieldValue('brandEndOtherText', formik.values.brandOtherText);
    }
  }, [formik.values.segment, formik.values.brand, sameAsShipTo]);

  const handleAddProductFields = () => {
    setVisibleProducts((prev) => (prev < 4 ? prev + 1 : prev));
  };

  const renderProductFields = (index) => (
    <Box key={index}>
      <Box sx={{display: 'inline-flex', width: '100%', justifyContent: 'space-between'}}>
        <Badge sx={{mt: 2, width: '78%', textAlign: 'right', fontSize: 12, display: 'inline-block', fontWeight: 500}}>
          {formik.values[`productCat${index + 1}Description`]?.length || 0} / {PRODUCT_DESCRIPTION_MAX_LENGTH} characters
        </Badge>
        <Badge sx={{mt: 2, width: '20%', textAlign: 'right', fontSize: 12, display: 'inline-block', fontWeight: 500}}>
          {formik.values[`productCat${index + 1}Code`]?.length || 0} / {PRODUCT_CODE_MAX_LENGTH} characters
        </Badge>
      </Box>

      <Box sx={{display: 'flex', width: '100%', gap: '15px'}}>
        <TextField
          id={`productCat${index + 1}`}
          select
          label={`Featured Category ${index + 1}` + (index === 0 ? '*' : '')}
          value={formik.values[`productCat${index + 1}`] ?? ''}
          onChange={(event) => formik.setFieldValue(`productCat${index + 1}`, event.target.value || 1)}
          sx={{width: 275}}
          variant="outlined"
        >
          {productCatList.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.categoryName}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          id={`productCat${index + 1}Description`}
          label="Product Name"
          variant="outlined"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values[`productCat${index + 1}Description`] ?? ''}
          sx={{width: 350}}
          inputProps={{maxLength: PRODUCT_DESCRIPTION_MAX_LENGTH}}
        />

        {/*<TextField*/}
        {/*  id={`productCat${index + 1}Innovation`}*/}
        {/*  select*/}
        {/*  label="Innovation"*/}
        {/*  value={formik.values[`productCat${index + 1}Innovation`] ?? ''}*/}
        {/*  onChange={(event) => formik.setFieldValue(`productCat${index + 1}Innovation`, event.target.value || null)}*/}
        {/*  sx={{width: 162.8}}*/}
        {/*  variant="outlined"*/}
        {/*>*/}
        {/*  <MenuItem value="">*/}
        {/*    <em>None</em>*/}
        {/*  </MenuItem>*/}
        {/*  {productInnoList.map(option => (*/}
        {/*    <MenuItem key={option.id} value={option.id}>*/}
        {/*      {option.name}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</TextField>*/}

        <TextField
          id={`productCat${index + 1}Code`}
          label="Worldwide Code"
          variant="outlined"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values[`productCat${index + 1}Code`] ?? ''}
          sx={{width: 162.8}}
          inputProps={{maxLength: PRODUCT_CODE_MAX_LENGTH}}
        />
      </Box>

      <FormHelperText className="error-message">
        {formik.touched[`productCat${index + 1}Description`] && formik.errors[`productCat${index + 1}Description`]
          ? formik.errors[`productCat${index + 1}Description`]
          : ' '}
        {index === 0 && formik.touched.productCat1 && formik.errors.productCat1 ?
          formik.errors.productCat1
          : ' '
        }
      </FormHelperText>
    </Box>
  );

  if (!formik.values.id) {
    return <Box sx={{my: 4}}>
      <Typography variant="h4" align="center">
        Loading Product Launch Details...
      </Typography>
    </Box>
  }

  return (
    <Container
      sx={{
        maxWidth: "1340px",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 2,
        mb: 2,
      }} fixed>

      <Box sx={{my: 4}}>
        <Typography variant="h4" align="center">
          Edit Product Launch Details
        </Typography>
      </Box>

      <Box className=""
           sx={{
             width: '70%'
           }}>

        <form onSubmit={formik.handleSubmit}>

          <FormControl sx={{mt: 2}} fullWidth>
            <Badge sx={{textAlign: 'right', fontSize: 12, display: 'inline-block', fontWeight: 500,}}>
              {formik.values.conceptName ? formik.values.conceptName.length : 0} / 150 characters
            </Badge>
            <TextField id="conceptName" label="Product Launch Name*" variant="outlined"
                       onChange={formik.handleChange}
                       onBlur={formik.handleBlur}
                       value={formik.values.conceptName ? formik.values.conceptName : ''}
                       fullWidth
                       inputProps={{
                         maxLength: 150,
                       }}
            />
          </FormControl>
          <FormHelperText className="error-message">
            {formik.touched.conceptName && formik.errors.conceptName ?
              formik.errors.conceptName
              : ' '}
          </FormHelperText>

          {/* <TextField
            id="mealPart"
            select
            label="Meal Part*"
            value={formik.values.mealPart ? formik.values.mealPart : ''}
            onChange={selectedOption => {
              formik.handleChange("mealPart")(selectedOption);
            }}
            sx={{minWidth: 220, mt: 2,}}
            variant="outlined"
          >
            {mealpartList.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.mealPartName}
              </MenuItem>
            ))}
          </TextField>
          <FormHelperText className="error-message">
            {formik.touched.mealPart && formik.errors.mealPart ?
              formik.errors.mealPart
              : ' '}
          </FormHelperText> */}

          <FormControl fullWidth>
            <Badge sx={{textAlign: 'right', fontSize: 12, display: 'inline-block', fontWeight: 500,}}>
              {formik.values.description ? formik.values.description.length : 0} / 275 characters
            </Badge>
            <TextField
              id="description" label="Product Launch Description*" variant="outlined"
              multiline
              rows={4}
              value={formik.values.description ? formik.values.description : ''}
              fullWidth
              inputProps={{
                maxLength: 275,
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </FormControl>
          <FormHelperText className="error-message">
            {formik.touched.description && formik.errors.description ?
              formik.errors.description
              : ' '}
          </FormHelperText>

          <Box sx={{display: 'block', width: '100%'}}>
            <FormControl sx={{mb: 2, mt: 3,}}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={['year', 'month']}
                  label="Launch Date*"
                  openTo='month'
                  minDate={dayjs('2023-01-15')}
                  maxDate={dayjs('2023-12-15')}
                  value={dayjs(formik.values.creationDate)}
                  disabled={true}
                  onChange={(value) => {
                    formik.setFieldValue('creationDate', Date.parse(value));
                  }}
                  renderInput={(params) => <TextField onKeyDown={onKeyDown} {...params} helperText={null}
                                                      name="creationDate"/>}
                />
              </LocalizationProvider>
            </FormControl>
          </Box>

          <Box sx={{ mt: 3 }}>
            <TextField
              id="chef"
              select
              label="Project Lead*"
              value={formik.values.chef || ''}
              onChange={formik.handleChange}
              name="chef"
              fullWidth
              variant="outlined"
            >
              {chefList.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.chefName}
                </MenuItem>
              ))}
            </TextField>

            <Typography
              variant="body2"
              sx={{ mt: 1.5, color: '#464646', fontStyle: 'italic' }}
            >
              *Contact Rachel Fisher or Bo Chhay to add in a new or missing Business Development Leader's information.
            </Typography>

            <FormHelperText error>
              {formik.touched.chef && formik.errors.chef ? formik.errors.chef : ' '}
            </FormHelperText>
          </Box>

          <RegionCountriesSelector regionList={regionList} formik={formik} />
          
          <Box sx={{ display: 'flex', gap: 6, mt: 3 }}>
            {/* Ship To Customer */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: '#666' }}>
                Ship To Customer:
                <InfoModal
                  title="Ship To Customer"
                  description="This is the customer (company) who will directly receive the produce we provide."
                  tooltip="Ship To Info"
                />
              </Typography>

              {/* Segment (Ship To Customer) */}
              <TextField
                id="segment"
                select
                label="Segment*"
                value={formik.values.segment || ''}
                onChange={(e) => {
                  formik.setFieldValue("segment", e.target.value);
                  fetchBrandsBySegmentId(e.target.value, setBrandList);
                }}
                fullWidth
                variant="outlined"
                sx={{ mb: 2 }}
              >
                {segmentList.map(option => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              {/* Brand (Ship To Customer) */}
              <Autocomplete
                id="brand-autocomplete"
                disabled={!formik.values.segment}
                options={brandListWithOther}
                getOptionLabel={(option) => option.brandName || ""}
                onChange={(event, value) => {
                  formik.setFieldValue('brand', value ? value.id : '');
                  // needs slight delay for formik to catch up on errors
                  setTimeout(() => {
                    formik.setFieldTouched('brand', true, true);
                  }, 0);
                  setShipToSearchTerm(undefined);
                  setFilteredBrands(brandListWithOther);
                  if (value && value.id !== OTHER_BRAND_OPTION.id) {
                    formik.setFieldValue('brandOtherText', '');
                  }
                }}
                inputValue={
                  shipToSearchTerm !== undefined
                    ? shipToSearchTerm
                    : brandListWithOther.find(x => x.id === formik.values.brand)?.brandName || ''
                }
                value={brandListWithOther.find(x => String(x.id) === String(formik.values.brand)) || null}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue === '') formik.setFieldValue('brandOtherText', '');
                  if (shipToSearchTerm === undefined && newInputValue === '') return;
                  setShipToSearchTerm(newInputValue);
                  const processedInputValue = newInputValue.trim();
                  setFilteredBrands(
                    processedInputValue ? fuse.search(processedInputValue).map(r => r.item) : brandListWithOther
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Search Brand" variant="outlined" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />

              {formik.values.brand === OTHER_BRAND_OPTION.id || formik.values.brandOtherText ?
                <TextField 
                  id="brandOtherText" 
                  label='Enter "Other" Brand Name' 
                  variant="outlined"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.brandOtherText ?? ''}
                  fullWidth
                  sx={{ mb: 2, marginTop: '15px' }}
                  inputProps={{ maxLength: 50 }}
                /> : null}
            </Box>

            {/* End Customer */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: '#666' }}>
                End Customer:
                <InfoModal
                  title="End Customer"
                  description="This is the customer (company) who will ultimately use the product."
                />
              </Typography>

              {/* Segment (End Customer) */}
              <TextField
                id="segmentEnd"
                select
                label="Segment*"
                value={formik.values.segmentEnd || ''}
                onChange={(e) => {
                  formik.setFieldValue("segmentEnd", e.target.value);
                  fetchBrandsBySegmentId(e.target.value, setBrandEndList);
                }}
                fullWidth
                disabled={sameAsShipTo}
                variant="outlined"
                sx={{ mb: 2 }}
              >
                {segmentList.map(option => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              {/* Brand (End Customer) */}
              <Autocomplete
                id="brand-end-autocomplete"
                disabled={!formik.values.segmentEnd || sameAsShipTo}
                options={brandEndListWithOther}
                getOptionLabel={(option) => option.brandName || ""}
                value={
                  brandEndListWithOther.find(
                    (x) => String(x.id) === String(formik.values.brandEnd)
                  ) || null
                }
                inputValue={
                  endCustomerSearchTerm !== undefined
                    ? endCustomerSearchTerm
                    : brandEndListWithOther.find(
                    (x) => x.id === formik.values.brandEnd
                  )?.brandName || ''
                }
                onInputChange={(event, newInputValue) => {
                  if (newInputValue === '') {
                    formik.setFieldValue('brandEndOtherText', '');
                  }
                  if (endCustomerSearchTerm === undefined && newInputValue === '') return;
                  setEndCustomerSearchTerm(newInputValue);
                  const processedInputValue = newInputValue.trim();
                  setFilteredBrandsEnd(
                    processedInputValue
                      ? fuseBrandsEnd.search(processedInputValue).map(r => r.item)
                      : brandEndListWithOther
                  );
                }}
                onChange={(event, value) => {
                  formik.setFieldValue('brandEnd', value ? value.id : '');
                  // needs slight delay for formik to catch up on errors
                  setTimeout(() => {
                    formik.setFieldTouched('brandEnd', true, true);
                  }, 0);
                  setEndCustomerSearchTerm(undefined);
                  setFilteredBrandsEnd(brandEndListWithOther);
                  if (value && value.id !== OTHER_BRAND_OPTION.id) {
                    formik.setFieldValue('brandEndOtherText', '');
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Search Brand (End Customer)" variant="outlined" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
              
              {formik.values.brandEnd === OTHER_BRAND_OPTION.id || formik.values.brandEndOtherText ?
                <TextField
                  id="brandEndOtherText"
                  label='Enter "Other" Brand Name'
                  variant="outlined"
                  onChange={formik.handleChange}
                  disabled={sameAsShipTo}
                  onBlur={formik.handleBlur}
                  value={formik.values.brandEndOtherText ?? ''}
                  fullWidth
                  sx={{ mb: 2, marginTop: '15px' }}
                  inputProps={{ maxLength: 50 }}
                /> : null}
          </Box>
        </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={sameAsShipTo}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSameAsShipTo(checked);
                  if (checked) {
                    // copy values and lock
                    formik.setFieldValue('segmentEnd', formik.values.segment);
                    formik.setFieldValue('brandEnd', formik.values.brand);
                    formik.setFieldValue('brandEndOtherText', formik.values.brandOtherText);
                  }
                }}
              />
            }
            label="'End Customer' same as 'Ship To Customer'"
          />

          <FormHelperText className="error-message">
            {
              (formik.touched.segmentEnd && formik.errors.segmentEnd) ||
              (formik.touched.brandEnd && formik.errors.brandEnd) ||
              (formik.touched.segment && formik.errors.segment) ||
              (formik.touched.brand && formik.errors.brand) ||
              (formik.touched.brandOtherText && formik.errors.brandOtherText) ||
              (formik.touched.brandEndOtherText && formik.errors.brandEndOtherText)
                ? 'All fields for both Ship To and End Customer are required.'
                : ' '
            }
          </FormHelperText>

          <FormControl fullWidth sx={{mt: 0,}}>
            <Badge sx={{textAlign: 'right', fontSize: 12, display: 'inline-block', fontWeight: 500,}}>
              {formik.values.pricePoint.length} / 30 characters
            </Badge>
            <TextField
              id="pricePoint" label="Retail or Menu Price Point (example: $12.99 USD)" variant="outlined"
              value={formik.values.pricePoint}
              fullWidth
              inputProps={{ maxLength: 30 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </FormControl>

          <FormControl fullWidth sx={{mt: 2,}}>
            <Badge sx={{textAlign: 'right', fontSize: 12, display: 'inline-block', fontWeight: 500,}}>
              {formik.values.websiteUrl.length} / 175 characters
            </Badge>
            <TextField
              id="websiteUrl" label="Provide website URL for additional information on this product launch." variant="outlined"
              value={formik.values.websiteUrl}
              fullWidth
              inputProps={{ maxLength: 125 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </FormControl>

          <Box sx={{mt: 5}}>
            <Divider textAlign="left">Health Choices:</Divider>
            <Typography variant="p" sx={{color: '#464646', fontSize: 15}}>
              Select the featured health attribute for this product launch.
              <br/><em>*Multiple health choices can be applied</em>
            </Typography>
            <HealthChoices healthOptions={healthOptList}/>
          </Box>

          <FormControl sx={{mt: 3, width: '100%'}}>
            <InputLabel id="health-choices-select-label">Health Choices</InputLabel>
            <Select
              id="health-choices"
              labelId="health-choices-select-label"
              multiple
              label="Health Choices"
              value={formik.values.healthOptions ?? []}
              onChange={selectedOption => {
                console.log(selectedOption)
                formik.handleChange("healthOptions")(selectedOption);
              }}
              variant="outlined"
            >
              {healthOptList.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{mt: 5}}>
            <Divider textAlign="left">Featured Category:</Divider>
            <Typography variant="p" sx={{color: '#464646', fontSize: 15}}>
              Select up to 4 product categories and enter associated product names and codes.
              {/*<ProductInnovationsModal productInnovations={productInnoList}/>*/}
              <br/><em>*Product names are limited to 80 characters each.</em>
            </Typography>
          </Box>

          {[...Array(visibleProducts)].map((_, index) => renderProductFields(index))}

          {visibleProducts < 4 && (
            <Button variant="outlined" onClick={handleAddProductFields} sx={{mt: 2}}>
              + Add Featured Category {visibleProducts + 1}
            </Button>
          )}

          <Divider textAlign="left" sx={{my: 3, mt: 5}}>Upload Product Launch Photo</Divider>
          <Typography variant="p" sx={{color: '#464646', fontSize: 15}}>
            For best results, product launch photo needs to be exactly 1056px wide by 650px tall <em>OR</em> 528px wide by
            325px tall.
          </Typography>

          <FormHelperText sx={{textAlign: 'right', mr: 2, color: '#ff9300'}}>
            {formik.touched.photo && formik.errors.photo ?
              formik.errors.photo
              : 'Maximum 5 MB'}
          </FormHelperText>
          <Box sx={{display: 'flex', width: '100%'}}>
            <FormControl sx={{
              mt: 2,
              mx: 2,
              mb: 2,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              width: '100%'
            }}>

              <Button variant="contained" component="label" size="large" sx={{color: '#fff', flex: '1 100%'}}>
                Select File
                <input hidden accept="image/png, image/jpeg, image/jpg" type="file" id="photo" name="photo"
                       onChange={(event) => {
                         setImage({
                           preview: URL.createObjectURL(event.currentTarget.files[0]),
                           raw: event.currentTarget.files[0]
                         });
                         formik.setFieldValue("photo", event.currentTarget.files[0]);
                         formik.setFieldValue("photoURL", URL.createObjectURL(event.currentTarget.files[0]));
                         formik.handleChange(event)
                       }}
                />
              </Button>

              <FormLabel id="upload-group" sx={{fontSize: 17, fontWeight: 500, width: '100%'}}>
                <img src={formik.values.photoURL} className="preview-image"/>
              </FormLabel>

            </FormControl>
          </Box>


          <Box sx={{textAlign: 'center', width: '100%', mt: 6}}>
            <FormHelperText className="error-message" sx={{textAlign: 'center'}}>
              {(formik.touched.conceptName && formik.errors.conceptName)
             // || (formik.touched.mealPart && formik.errors.mealPart)
              || (formik.touched.description && formik.errors.description)
              || (formik.touched.chef && formik.errors.chef)
              || (formik.touched.segment && formik.errors.segment)
              || (formik.touched.brand && formik.errors.brand)
              || (formik.touched.brandEnd && formik.errors.brandEnd)
              || (formik.touched.segmentEnd && formik.errors.segmentEnd)
              || (formik.touched.regionCountries && formik.errors.regionCountries)
              || (formik.touched.brandOtherText && formik.errors.brandOtherText)
              || (formik.touched.brandEndOtherText && formik.errors.brandEndOtherText)
              || (formik.touched.productCat1Description && formik.errors.productCat1Description)
              || (formik.touched.productCat1 && formik.errors.productCat1)
              || (formik.touched.productCat2Description && formik.errors.productCat2Description)
              || (formik.touched.productCat3Description && formik.errors.productCat3Description)
              || (formik.touched.productCat4Description && formik.errors.productCat4Description)
                ? 'Please enter all required fields.'
                : ' '}
            </FormHelperText>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              type="submit"
              sx={{
                mt: 2,
                mb: 6,
                px: 6,

              }}
              disabled={savingConcept}
            >
              UPDATE Product Launch
            </Button>
          </Box>
          {!!snackbar && (
            <Snackbar open onClose={handleCloseSnackbar} autoHideDuration={1600}>
              <Alert {...snackbar} onClose={handleCloseSnackbar}/>
            </Snackbar>
          )}
        </form>
      </Box>
    </Container>
  );
}



